import { Box } from "@mui/material";
import CustomTableRow from "../table/CustomTableRow";
import { DeleteOutlined, EditOutlined } from "@mui/icons-material";
import React, { useState } from "react";
import useAuthFetch from "../../hooks/useAuthFetch";
import ConfirmBox from "../ConfirmBox";
import toast from "react-hot-toast";
import Cookies from "js-cookie"

export default function TemplateTableRow({
  row,
  refetch,
  setOpen,
  setSelectedRow,
}) {
  const [openErr, setOpenErr] = useState(false)
  const [openConfirm, setOpenConfirm] = useState(false)
  const [errMsg, setErrMsg] = useState(null)
  const handleUpdate = () => {
    setSelectedRow(row);
    setTimeout(() => (
      setOpen(true)
    ), 1000)
  };
  const customFetch = useAuthFetch();

  const handleDelete = async () => {
    try {
      const url = new URL(
        `${process.env.REACT_APP_API_URL}/v1/dashboard/agentAssociation/delete`
      );
      const method = "POST"
      const bodyContent = {
        agentCode: row?.agentCode
      }
      const { response, status, message } = await customFetch(
        url,
        method,
        bodyContent
      );
      if (status !== 200) {
        setOpenConfirm(false)
        setOpenErr(true)
        setErrMsg(message)
        console.log("Error in deleting template", response);
        return;
      }
      toast.success("Agent-Template Association Deleted Succesfully!", {
        position: "bottom-right",
      })
      setOpenConfirm(false)
      refetch();
    } catch (error) {
      console.error("Error delete template:", error);
    }
  };
  const ShowButtons = () => {

    return (
      JSON.parse(Cookies.get("userDets")).role === "ADMIN" ?
        <Box
          sx={{
            display: "flex",
            gap: 1,
          }}
        >
          <button onClick={handleUpdate}>
            <EditOutlined className="w-5 h-5 text-black-150" />
          </button>
          <button onClick={() => setOpenConfirm(true)}>
            <DeleteOutlined className="w-5- h-5 text-black-150" />
          </button>
        </Box> : "-"
    );
  };

  return (<>
    <CustomTableRow
      columns={[
        {
          text: row.agentCode,
        },
        {
          text: row.templateId,
        },
        {
          text: row.templateName,
        },
        {
          text: row.qnaTemplateName || "-",
        },
        {
          text: row.qnaTemplateId || "-",
        },
        {
          text: row.verificationProfileName || "Default",
        },
        {
          actions: [ShowButtons],
        },
      ]}
    ></CustomTableRow>
    <ConfirmBox
      open={openErr}
      setOpen={setOpenErr}
      buttonText={"Close"}
      text={errMsg ? errMsg : "An error occurred"}
    />
    <ConfirmBox
      open={openConfirm}
      setOpen={setOpenConfirm}
      buttonText={"Confirm"}
      buttonHandler={() => {
        handleDelete()
      }}
      extraButtonText={"Cancel"}
      extraButtonHandler={() => {
        setOpenConfirm(false)
      }}
      text={"Are you sure you want to delete the association?"}
    />
  </>
  );
}
